import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ApolloProvider } from 'react-apollo';
import { ThemeProvider } from 'styled-components';
import { Provider as ReduxProvider, connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

import { getThemeParameters } from './theme/selector';

const ConnectedThemeProvider = connect(state => ({ theme: getThemeParameters(state) }))(ThemeProvider);

export default class Provider extends Component {
    static propTypes = {
        children: PropTypes.element.isRequired,
        client: PropTypes.object,
        store: PropTypes.object.isRequired,
    };

    render() {
        return (
            this.props.client
                ? <ApolloProvider client={this.props.client}>{this.renderRestOfHOCs()}</ApolloProvider>
                : this.renderRestOfHOCs()
        );
    }

    renderRestOfHOCs() {
        const { locale = 'en' } = this.props;
        return (
            <ReduxProvider store={this.props.store}>
                <ConnectedThemeProvider>
                    <IntlProvider
                        locale={locale}
                        messages={this.props.messages}
                    >
                        {this.props.children}
                    </IntlProvider>
                </ConnectedThemeProvider>
            </ReduxProvider>
        );
    }
}
